/* ============================================================
   TAIBI — FOOTER
   Due sole cose: la fisarmonica dell'indice e il «torna su».

   ⚠️ I pannelli nascono APERTI nel markup. Senza JS restano aperti, che su
   telefono è lungo ma leggibile; chiuderli col markup e non riaprirli
   sarebbe invece un footer inaccessibile a JS spento. Il JS li chiude su
   telefono, non il contrario.

   ⚠️ Lo stato lo decide la LARGHEZZA, non l'HTML, così il cambio di
   orientamento o una finestra ridimensionata lo aggiornano.
   ============================================================ */
(function () {
  'use strict';

  var DA_COMPUTER = '(min-width: 750px)';

  function pannelli(radice) {
    var largo = window.matchMedia(DA_COMPUTER).matches;
    var gruppi = (radice || document).querySelectorAll('.foot-taibi__gruppo');
    for (var i = 0; i < gruppi.length; i++) gruppi[i].open = largo;
  }

  function collegaTornaSu(radice) {
    var bottoni = (radice || document).querySelectorAll('[data-foot-su]');
    for (var i = 0; i < bottoni.length; i++) {
      if (bottoni[i].getAttribute('data-collegato') === 'sì') continue;
      bottoni[i].setAttribute('data-collegato', 'sì');
      bottoni[i].addEventListener('click', function () {
        /* ⚠️ Un `behavior` esplicito in JS SCAVALCA lo `scroll-behavior`
           del blocco prefers-reduced-motion: la preferenza va letta anche
           qui, o chi ha chiesto meno movimento se lo ritrova comunque. */
        var motoRidotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: motoRidotto ? 'auto' : 'smooth' });
      });
    }
  }

  function avvia(radice) {
    pannelli(radice);
    collegaTornaSu(radice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { avvia(); });
  } else {
    avvia();
  }

  window.addEventListener('resize', function () { pannelli(); });

  /* ⚠️ Nell'editor Shopify rimonta il markup senza ricaricare la pagina:
     senza questo, il footer appena modificato resterebbe con i pannelli
     nello stato sbagliato e il «torna su» morto. */
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
})();
